import React, { memo } from 'react';

export const FEATURE_GRIDS: Record<string, { rows: number; cols: number }> = {
  '多机位九宫格': { rows: 3, cols: 3 },
  '剧情推演四宫格': { rows: 2, cols: 2 },
  '25宫格连贯分镜': { rows: 5, cols: 5 },
  '电影级光影校正': { rows: 1, cols: 1 },
  '角色三视图生成': { rows: 1, cols: 3 },
  '画面推演 - 3秒后': { rows: 1, cols: 1 },
  '画面推演 - 5秒前': { rows: 1, cols: 1 },
};

interface GridOverlayProps {
  rows: number;
  cols: number;
  interactive?: boolean;
  selectedCells?: Set<string>;
  onCellClick?: (cellId: string) => void;
}

export const GridOverlay: React.FC<GridOverlayProps> = memo(({ rows, cols, interactive = false, selectedCells, onCellClick }) => {
  return (
    <div
      className={`absolute inset-0 z-10 ${interactive ? '' : 'pointer-events-none'}`}
      style={{
        display: 'grid',
        gridTemplateColumns: `repeat(${cols}, 1fr)`,
        gridTemplateRows: `repeat(${rows}, 1fr)`,
      }}
    >
      {Array.from({ length: rows * cols }).map((_, i) => {
        const row = Math.floor(i / cols) + 1;
        const col = (i % cols) + 1;
        const cellId = `${row}-${col}`;
        const isSelected = interactive && selectedCells?.has(cellId);
        return (
          <div
            key={cellId}
            className={`relative border ${interactive ? 'border-white/10 cursor-pointer transition-all' : 'border-white/20'}`}
            onClick={interactive && onCellClick ? (e) => { e.stopPropagation(); onCellClick(cellId); } : undefined}
          >
            {isSelected ? (
              <>
                <div className="absolute inset-0 bg-black/50 z-[1]" />
                <div className="absolute inset-0 border-2 border-white z-[2]" />
                <span className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 text-sm font-medium text-white z-[3]">
                  {cellId}
                </span>
              </>
            ) : (
              <span className={`absolute top-1 left-1 text-xs font-medium px-1 rounded z-[1] ${interactive ? 'text-white/40 bg-black/30' : 'text-white/50 bg-black/40'}`}>
                {cellId}
              </span>
            )}
          </div>
        );
      })}
    </div>
  );
});

export const AudioVisualizer = ({ isPlaying }: { isPlaying: boolean }) => (
  <div className="flex items-center justify-center gap-[2px] h-12 w-full opacity-60">
    {[...Array(20)].map((_, i) => (
      <div
        key={i}
        className="w-1 bg-cyan-400/80 rounded-full"
        style={{
          height: isPlaying ? `${20 + Math.random() * 80}%` : '20%',
          transition: 'height 0.1s ease',
          animation: isPlaying ? `pulse 0.5s infinite ${i * 0.05}s` : 'none'
        }}
      />
    ))}
  </div>
);
